const RailsUtility = {
  convertToEnumFormat(value: string) {
    return value.replace(/ /g, '_');
  },

  convertToCasedEnumFormat(value: string) {
    return this.convertToEnumFormat(value.toLowerCase())
  },

  convertFromEnumFormat(value: string) {
    return value.replace(/_/g, ' ');
  },

  convertFromCasedEnumFormat(value: string) {
    if (!value) return value;
    return capitalizeEachWord(this.convertFromEnumFormat(value))
  },

  convertStatusToApi(status?: string) {
    if (!status) return status;
    return status.toLowerCase();
  },

  convertStatusFromApi(status?: string) {
    if (!status) return status;
    return status.charAt(0).toUpperCase() + status.slice(1);
  },
};

export default RailsUtility;

function capitalizeEachWord(value: string) {
  const words = value.split(' ');

  const capitalizedWords = words.map(word => {
    if (word.length > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }
    return word;
  });
  return capitalizedWords.join(' ');
}